import React, { useEffect } from 'react';

const RedirectToHome = () => {
  useEffect(() => {
    window.location.href = `${
      window.location.origin
    }/?openAccountModal=signIn&ReturnUrl=${encodeURIComponent('/purchase')}`;
  }, []);

  return null;
};

const AccountLogin = () => {
  return <RedirectToHome />;
};

export default AccountLogin;
